import * as actions from "../constants/actionTypes";

export const INITIAL_STATE = {
    open: false,
    data: {},
    reasons: [],
    reported: false,
    update: 0
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actions.REPORT_MODAL_OPEN:
            return {
                ...state,
                open: true,
                data: action.payload
            }
        case actions.REPORT_MODAL_CLOSE:
            return {
                ...state,
                open: false,
                data: {}
            }
        case actions.GET_REPORT_MODAL_REASON_DATA_SUCCESS:
            return {
                reasons: action.payload
            }
        case actions.POST_REPORT_SUCCESS:
            return {
                ...state,
                // reasons: action.payload,
                reported: true,
                update: state.update + 1
            }
        default:
            return state;
    }
}